export default window.location.hostname === 'localhost' ||
  window.location.search.includes('debug=true');
